export default "__VITE_ASSET__wScu$ztD__"